<template lang="pug">
.select-end-date
  el-row
    el-col(:span="4").required {{ $t('方案上传截止日期') }}
    el-col(:span="10")
      span(v-if="isView") {{ endDate | formatDate}}
      el-date-picker(
        v-else
        :value="endDate"
        type="date"
        format="yyyy/MM/dd"
        :placeholder="IE ? '' : $t('选择日期')"
        value-format="yyyy-MM-dd"
        @input="v => $emit('input', v)"
        :picker-options="pickerOptions"
      )

</template>

<script>
import { formatDate } from '@/umcc/util'

export default {
  model: {
    prop: 'endDate'
  },
  props: {
    endDate: String,
    default () {
      return ''
    }
  },
  data () {
    return {
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now()
        }
      }
    }
  },
  filters: {
    formatDate
  }
}
</script>
